import React from 'react';
import classNames from 'classnames';

import {Layouts} from '@components';
import {Props} from './types';

import './index.scss';

const Main: React.FC<Props> = props => {
  const isAuthed = props.me.sub;

  return (
    <div className={classNames('a__privacy-policy', {after: isAuthed})}>
      {!isAuthed && (
        <Layouts.Header.Before
          history={props.history}
          location={props.location}
          match={props.match}
        />
      )}
      <div className="b__content-main">
        <div className="w__privacy-policy-content">
          <div className="w__privacy-policy-header">
            <span>プライバシーポリシー</span>
          </div>
          <div className="w__privacy-policy-messages">
            {/* ダミー文言 */}
            <span>
              株式会社ターン・アンド・フロンティア（以下、「当社」といいます。）は、当社が提供・運営する「AnpiChecker」（以下、「本サービス」といいます。）におけるプライバシー情報の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。
              ユーザーは、本サービスを利用するにあたり、本ポリシーに従って当社が利用者情報を取扱うことに同意するものとします。
              <br />
              <br />
              第１条（プライバシー情報）
              <br />
              <br />
              プライバシー情報のうち「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、携帯番号、連絡先その他の記述等により特定の個人を識別できる情報を指します。
              また、ユーザーがAnpiCheckerを使用することを許諾し、AnpiCheckerのID及びパスワードを入力した場合に取得できる氏名、ニックネーム、メールアドレス、
              プライバシー情報のうち「履歴情報および特性情報」とは、
              上記に定める「個人情報」以外のものをいい、ユーザーが検索した検索キーワード、利用日時、利用方法、利用環境、性別、職業、年齢、ユーザーのIPアドレス、クッキー情報、位置情報、端末の個体識別情報など、ユーザーがAnpiChecker上で登録した情報を指します。
              <br />
              <br />
              第２条（プライバシー情報の収集方法）
              <br />
              <br />
              当社は、ユーザーが利用登録をする際に氏名、生年月日、住所、携帯番号、メールアドレスなどの個人情報を収集することがあります。
              当社は、ユーザーについて、利用したサービスやソフトウエア、閲覧したページや広告の履歴、検索した検索キーワード、利用日時、利用方法、利用環境（携帯端末を通じて利用する場合の当該端末の通信状態、利用に際しての各種設定情報なども含みます）、IPアドレス、クッキー情報、位置情報、端末の個体識別情報などの履歴情報および特性情報を、ユーザーが当社や提携先のサービスを利用またはページを閲覧する際に収集します。
              <br />
              <br />
              第３条（個人情報を収集・利用する目的）
              <br />
              <br />
              当社が個人情報を収集・利用する目的は、以下のとおりです。
              <br />
              <br />
              （1）ユーザーが自分の登録情報の閲覧や修正、利用状況の閲覧をするために、氏名、住所、連絡先、支払方法などの登録情報、利用したサービスなどに関する情報を表示する目的
              <br />
              （2）ユーザーにお知らせや連絡をするためにメールアドレスを利用する場合やユーザーに必要に応じて連絡したりするため、氏名や住所などの連絡先情報を利用する目的
              <br />
              （3）ユーザーの本人確認を行うために、氏名、生年月日、住所、携帯番号などの情報を利用する目的
              <br />
              （4）第三者に損害を発生させたりするなど、本サービスの利用規約に違反したユーザーや、不正・不当な目的でサービスを利用しようとするユーザーの利用を制限するために、利用態様、氏名や住所など個人を特定するための情報を利用する目的
              <br />
              （5）ユーザーからのお問い合わせに対応するために、お問い合わせ内容や代金の請求に関する情報など当社がユーザーに対してサービスを提供するにあたって必要となる情報や、ユーザーのサービス利用状況、連絡先情報などを利用する目的
              <br />
              （6）ユーザーへの連絡、当社がおすすめする商品・サービスなどの各種情報の提供や、マーケティング（調査、アンケートの実施等）、データ分析、本サービスの研究や開発などに利用する目的
              <br />
              （7）上記の利用目的に付随する目的
              <br />
              <br />
              第４条（個人情報の第三者提供）
              <br />
              <br />
              当社は、次に掲げる場合を除いて、あらかじめユーザーの同意を得ることなく、第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。
              <br />
              （1）法令に基づく場合
              <br />
              （2）人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
              <br />
              （3）公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
              <br />
              （4）国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
              <br />
              （5）予め次の事項を告知あるいは公表をしている場合
              <br />
              &emsp;
              （5-1）当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合
              <br />
              &emsp;
              （5-2）合併その他の事由による事業の承継に伴って個人情報が提供される場合
              <br />
              <br />
              第５条（個人情報の確認、訂正および削除）
              <br />
              <br />
              ユーザーは、当社所定の方法により、自らの個人情報を確認することができ、ユーザーにおいて訂正または削除することができます。
              ユーザーが自らの個人情報の削除を求めるときは、第８条のお問い合わせ窓口まで連絡するものとし、当社に対して個人情報の訂正または削除を請求することができます。
              当社は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正または削除を行い、これをユーザーに通知します。
              <br />
              <br />
              第６条（個人情報の利用停止等）
              <br />
              <br />
              当社は、本人から、個人情報が利用目的の範囲を超えて取り扱われているという理由、または不正の手段により取得されたものであるという理由により、その利用の停止または消去（以下、「利用停止等」といいます。）を求められた場合には、必要な調査を行い、その結果に基づき、個人情報の利用停止等を行い、その旨を本人に通知します。ただし、個人情報の利用停止等に多額の費用を有する場合、その他利用停止等を行うことが困難な場合であって、本人の権利利益を保護するために必要なこれに代わるべき措置をとれる場合は、この代替策を講じます。
              <br />
              <br />
              第７条（プライバシーポリシーの変更）
              <br />
              <br />
              本ポリシーの内容は、ユーザーに通知することなく、変更することができるものとします。
              当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
              <br />
              <br />
              第８条（お問い合わせ窓口）
              <br />
              <br />
              本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。
              <br />
              <br />
              住所：大阪府大阪市西区新町1丁目5番7 四ツ橋ビルディング
              <br />
              社名：株式会社ターン・アンド・フロンティア
              <br />
              <br />
              以上
              <br />
              <br />
              2021年9月2日 改定
            </span>
          </div>
        </div>
      </div>
      {!isAuthed && <Layouts.Footer.Main />}
    </div>
  );
};

export default Main;
